import React from "react";
import Expander from "../../Expander";
import { getVarsoUrl } from "../../../common/helpers/helpers";
import { diseaseTableHeaders } from "./Constants";

export const getDiseaseRelationsTableMobile = (items) => {
  return (
    <div>
      <Expander showMore="5">
        {items.map((item) => {
          return (
            <dl className="dl-horizontal varsome-dl-horizontal" key={item.key}>
              {diseaseTableHeaders.map((i) => {
                if (i.key === "name") {
                  return (
                    <span key={i.key}>
                      <dt className="col-12 col-xs-12">{i.title}</dt>
                      <dd className="col-12 col-xs-12">
                        <a
                          href={getVarsoUrl(item.diseaseNameIdUrl)}
                          target="_blank"
                        >
                          {item.name || "-"}
                        </a>
                      </dd>
                    </span>
                  );
                }
                if (item[i.key] !== null) {
                  return (
                    <span key={i.key}>
                      <dt className="col-12 col-xs-12">{i.title}</dt>
                      <dd className="col-12 col-xs-12">{item[i.key] || "-"}</dd>
                    </span>
                  );
                }
                return null;
              })}
            </dl>
          );
        })}
      </Expander>
    </div>
  );
};
